import NiceModal from "@ebay/nice-modal-react";
import { adminRequester } from "App";
import P from "components/P";
import AdminCustomButton, { style } from "components/buttons/AdminCustomButton";
import InputText from "components/inputs/InputText";
import FlexChild from "layouts/flex/FlexChild";
import FlexGrid from "layouts/flex/FlexGrid";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import ModalBase from "modals/base/ModalBase";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
const SupportDetailModal = NiceModal.create((props) => {
    const { t } = useTranslation();
    const { onSuccess } = props;
    const [withHeader, withFooter] = [false, false];
    const [width, height] = ["max-content", "max-content"];
    const withCloseButton = true;
    const clickOutsideToClose = true;
    const modal = useRef();

    return (
        <ModalBase
            borderRadius={"10px"}

            title={"게시판 관리"}
            ref={modal}
            width={width}
            height={height}
            withHeader={withHeader}
            withFooter={withFooter}
            withCloseButton={withCloseButton}
            clickOutsideToClose={clickOutsideToClose}
        >
            {
                props.detail === "shipping" ?
                    <P>{props.detail}</P>
                    :
                    props.detail === "call" ?
                        <PaddingWrapper padding={30}>
                            <VerticalFlex>
                                <FlexChild>
                                    <P size={24} weight={700}>고객센터</P>
                                </FlexChild>
                                <FlexChild>
                                    <P>영업시간: 월 ~ 금 9:30 ~17:30 (공휴일 휴무)</P>
                                </FlexChild>
                                <FlexChild>
                                    <P>점심시간: 12:00 ~ 13:00</P>
                                </FlexChild>
                            </VerticalFlex>
                        </PaddingWrapper>
                        :
                        <img src={props.detailImg} />
            }
        </ModalBase>
    );
});

export default SupportDetailModal;
